const updateProp = (state, action) => {
  const newState = { ...state };
  newState[action.key] = action.value;
  return newState;
};

export default updateProp;
